import request from '@/utils/request'

// 订单任务文档-------------------------------------------------------------------------------------------
// 根据OMS平台任务单号查询详细信息
export function getInfoByOutOrderItemNo (val) {
  return request({
    url: `/api/ots/open/orderItem/getInfoByOutOrderItemNo/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
